module.exports = __webpack_public_path__ + "img/qiantong.360c356e.jpg";